"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PrimaryPositiveIssueTag = 'PrimaryIssuePositive';
// const PrimaryPositiveRatingTag = 'PrimaryRatingPositive';
var SecondaryPositiveIssueTag = 'SecondaryIssuePositive';
// const SecondaryPositiveRatingTag = 'SecondaryRatingPositive';
var TertiaryPositiveIssueTag = 'TertiaryIssuePositive';
// const TertiaryPositiveRatingTag = 'TertiaryRatingPositive';

var PrimaryNegativeIssueTag = 'PrimaryIssueNegative';
// const PrimaryNegativeRatingTag = 'PrimaryRatingNegative';
var SecondaryNegativeIssueTag = 'SecondaryIssueNegative';
// const SecondaryNegativeRatingTag = 'SecondaryRatingNegative';
var TertiaryNegativeIssueTag = 'TertiaryIssueNegative';
// const TertiaryNegativeRatingTag = 'TertiaryRatingNegative';
var _default = exports["default"] = function _default(_ref) {
  var response = _ref.response,
    initialValueSettings = _ref.initialValueSettings;
  var initialValues = {};
  var base = (0, _get2["default"])(response, initialValueSettings.basePath);
  initialValues.negative = {
    userRows: []
  };
  initialValues.positive = {
    userRows: []
  };

  // primary neg
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PrimaryNegativeIssueTag])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[PrimaryNegativeIssueTag]]
    });
  }

  // secondary neg
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[SecondaryNegativeIssueTag])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[SecondaryNegativeIssueTag]]
    });
  }

  // tertiary neg
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[TertiaryNegativeIssueTag])) {
    initialValues.negative.userRows.push({
      columns: [base.InitialValues.devTags[TertiaryNegativeIssueTag]]
    });
  }

  // primary pos
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[PrimaryPositiveIssueTag])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[PrimaryPositiveIssueTag]]
    });
  }
  // secondary pos
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[SecondaryPositiveIssueTag])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[SecondaryPositiveIssueTag]]
    });
  }
  // tertiary pos
  if (!(0, _isNil2["default"])(base.InitialValues.devTags[TertiaryPositiveIssueTag])) {
    initialValues.positive.userRows.push({
      columns: [base.InitialValues.devTags[TertiaryPositiveIssueTag]]
    });
  }
  return initialValues;
};